exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-login-user-profile-modal .login-user-profile-form-label[data-v-3171a8a4]{margin-bottom:1rem;font-weight:500;font-size:1rem;line-height:1.5rem}", ""]);

// exports
